import { Link } from 'react-router-dom';
import { mediaList } from '@/mocks/media';
import { useSeo } from '@/hooks/useSeo';
import HeroCarousel from './components/HeroCarousel';
import CategoryEntries from './components/CategoryEntries';
import LatestSection from './components/LatestSection';

function IntroSection() {
  const total = mediaList.length;
  const stats = [
    { value: `${total * 120}+`, label: '收录影视', icon: 'ri-film-line' },
    { value: '24', label: '内容分类', icon: 'ri-price-tag-3-line' },
    { value: '每日', label: '持续更新', icon: 'ri-refresh-line' },
    { value: '高清', label: '画质体验', icon: 'ri-hd-line' },
  ];

  return (
    <section className="bg-background-100 py-14">
      <div className="container-page">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-2 lg:items-center">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
              <i className="ri-star-smile-line"></i>
              关于天堂影视
            </span>
            <h2 className="mt-4 text-2xl font-bold text-foreground-950 md:text-3xl">
              发现属于你的下一部好剧
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              天堂影视专注于为影视爱好者提供便捷的内容发现体验。无论你想追一部刚上线的热门电影，
              还是想找一部适合周末放松的温情剧集，都可以通过分类浏览、多维筛选与搜索快速找到目标。
            </p>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              我们还持续整理影视行业的动态与推荐专题，帮助你在海量作品中做出更好的选择。
              所有内容均为演示数据，播放功能为演示状态，正式接口待接入。
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              <Link
                to="/category/movie"
                className="flex items-center gap-2 rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-compass-3-line text-lg"></i>
                浏览影视库
              </Link>
              <Link
                to="/about"
                className="flex items-center gap-2 rounded-md border border-background-300 px-5 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-information-line text-lg"></i>
                了解我们
              </Link>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4">
            {stats.map((stat) => (
              <div
                key={stat.label}
                className="rounded-lg border border-background-200 bg-background-50 p-5"
              >
                <span className="flex h-10 w-10 items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
                  <i className={`${stat.icon} text-xl`}></i>
                </span>
                <p className="mt-3 text-xl font-bold text-foreground-950">{stat.value}</p>
                <p className="text-sm text-foreground-500">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default function Home() {
  useSeo({
    title: '天堂影视-最新电影电视剧在线播放与资讯平台',
    description:
      '天堂影视为您提供最新电影、电视剧的丰富资源和影视资讯，涵盖多种类型与热门剧集，方便用户在线查询与了解影视动态。',
    keywords: '天堂影视,影视资源,在线电影,电视剧,影视资讯,电影推荐,影视平台,热门影视',
  });

  const featured = [...mediaList].sort((a, b) => b.hot - a.hot).slice(0, 5);

  return (
    <>
      <HeroCarousel items={featured} />
      <CategoryEntries />
      <LatestSection />
      <IntroSection />
    </>
  );
}